'use strict';

import appStore from '@uw-it-sis/lib-react/lib/AppStore';

const httpClient = appStore.getHttpClient();

class Api {
    constructor() {
        this.baseUrl = "api";
    }

    getImportInfo() {
        return httpClient.doGet(`${this.baseUrl}/socialImport/info`, 'getImportInfo');
    }

    getImportHistory() {
        return httpClient.doGet(`${this.baseUrl}/socialImport/history`, 'getImportHistory');
    }

    async runImport() {
        return await httpClient.doPut(`${this.baseUrl}/socialImport/run`, null, 'runImport');
    }

    async searchForSchedules(postBody) {
        return await httpClient.doPost(`${this.baseUrl}/schedule/search`, postBody, 'searchCourses');
    }

    saveSchedule(termId, postBody) {
        return httpClient.doPost(`${this.baseUrl}/schedule/schedules/${termId}`, postBody, 'saveSchedule');
    }

    getSavedSchedules(termId) {
        return httpClient.doGet(`${this.baseUrl}/schedule/schedules/${termId}`, 'getSavedSchedules');
    }

    deletePinnedSchedule(scheduleId) {
        return httpClient.doDelete(`${this.baseUrl}/schedule/schedules/${scheduleId}`, 'deletePinnedSchedule');
    }

    getReservedTimeFilters(termId) {
        return httpClient.doGet(`${this.baseUrl}/schedule/reservedTimes/${termId}`, 'getReservedTimeFilters');
    }

    addReservedTimeFilter(postBody) {
        return httpClient.doPost(`${this.baseUrl}/schedule/reservedTimes`, postBody, 'addReservedTimeFilter');
    }

    updateReservedTimeFilter(reserveTimeId, putBody) {
        return httpClient.doPut(`${this.baseUrl}/schedule/reservedTimes/${reserveTimeId}`, putBody, 'updateReservedTimeFilter');
    }

    deleteReservedTimeFilter(reserveTimeId) {
        return httpClient.doDelete(`${this.baseUrl}/schedule/reservedTimes/${reserveTimeId}`, 'deleteReservedTimeFilter');
    }

    getPlanTerms(termId, validate) {
        return httpClient.doGet(`${this.baseUrl}/plan/terms?termId=${termId}&validate=${validate}`, 'getPlanTerms');
    }

    getAllTerms() {
        return httpClient.doGet(`${this.baseUrl}/plan/terms`, 'getAllTerms');
    }
    
    getPreregStatus(termId) {
        return httpClient.doGet(`${this.baseUrl}/preregStatus/${termId}`, 'getPreregStatus');
    }

    getAcknowledgements(params) {
        let url;
        if ( (appStore.isBackdoorAllowed() || appStore.isDevMode()) && params ) {
            url = `${this.baseUrl}/acknowledgements${params}`
        } else {
            url = `${this.baseUrl}/acknowledgements`
        }
        return httpClient.doGet(url, 'getAcknowledgements');
    }

    updateAcknowledgements(postBody) {
        return httpClient.doPost(`${this.baseUrl}/acknowledgements`, postBody, 'updateAcknowledgements');
    }

    getAddress() {
        return httpClient.doGet(`${this.baseUrl}/address`, 'getAddress');
    }

    // Not in use currently as this is being done in SPS for right now, but future work to bring that into MyPlan
    updateAddress(postBody) {
        return httpClient.doPost(`${this.baseUrl}/address`, postBody, 'updateAddress');
    }

    getOptionalCharges(termId) {
        return httpClient.doGet(`${this.baseUrl}/optcharges/${termId}`, 'getOptionalCharges');
    }

    updateOptionalCharges(postBody) {
        return httpClient.doPost(`${this.baseUrl}/optcharges`, postBody, 'updateOptionalCharges');
    }

    getRegistration(termId) {
        // regdev path for development // ${termId}
        return httpClient.doGet(`${this.baseUrl}/registration/${termId}`, 'getRegistration');
    }

    postRegistration(termId, postBody) {
        return httpClient.doPost(`${this.baseUrl}/registration/${termId}`, postBody, 'postRegistration');
    }
}

export default new Api();